import { numberToPrettyString, plural } from '@cian/utils';

import { WorkplaceInCoworkingType } from 'shared/enums/WorkplaceInCoworkingType';

export function getPlaceLabel(type: WorkplaceInCoworkingType, count: number): string {
  const pluralText = plural(count, ['закреплённое место', 'закреплённых места', 'закреплённых мест']);

  switch (type) {
    case WorkplaceInCoworkingType.FlexibleWorkplace:
      return `${numberToPrettyString(count)} не${pluralText}`;

    case WorkplaceInCoworkingType.FixedWorkplace:
      return `${numberToPrettyString(count)} ${pluralText}`;

    default:
      throw new Error(`getPlaceLabel поле ${type} в енаме WorkplaceInCoworkingType не объявлено`);
  }
}
